export default "__VITE_ASSET__d17e0418__"